import type { FC } from 'react';
import { useNormalizedFolderStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import LayoutContainer from '../../_partials/LayoutContainer';
import ProductsHeader from '../../../products/ProductsHeader';
import ScrollableList from '../../_partials/ScrollableList';
import { GALLERY_SUBFOLDERS_STREAM } from '../../../../../constants';
import StudioBlankSlate from '../../../StudioBlankSlate';
import StudioTableBatchBanner from '../../../StudioTableBatchBanner';
import PremiumGalleryListItem from '../../items/PremiumGalleryListItem';

interface Props {}

const ProductsLayout: FC<Props> = () => {
  const { streamId } = GALLERY_SUBFOLDERS_STREAM;
  const { items: galleries, isFetching } = useNormalizedFolderStream(
    streamId,
    GallectionType.GALLERY
  );
  const hasItems = galleries.length > 0;

  return (
    <LayoutContainer>
      <StudioTableBatchBanner />
      <ProductsHeader />
      {hasItems && (
        <ScrollableList
          isFetching={isFetching}
          results={galleries}
          renderItem={gallery => (
            <PremiumGalleryListItem key={gallery.folderId} gallery={gallery} />
          )}
        />
      )}
      {!hasItems && <StudioBlankSlate />}
    </LayoutContainer>
  );
};
ProductsLayout.displayName = 'ProductsLayout';

export default ProductsLayout;
